// src/components/Forms/SelectCompanies.jsx
import { useEffect } from 'react';
import { companiesApi } from '../../../hooks/companiesApi';
import LoadingSpinner from '../../../components/UI/LoadingSpinner';
import ErrorMessage from '../../../components/UI/ErrorMessage';
/**
 * Componente Select que lista los NIT de las empresas.
 * @param {string} value - NIT de la empresa seleccionada (controlado)
 * @param {function} onChange - Callback que recibe el NIT seleccionado
 * @param {string} placeholder - Texto por defecto cuando no hay selección
 * @param {string} className - Clases CSS adicionales
 */
export const SelectCompanies = ({
  value,
  onChange,
  placeholder = 'Seleccione una empresa',
  className = '',
}) => {
  const { companies, loading, error, fetchCompanies } = companiesApi();

  // Si el hook no carga automáticamente, puedes llamar a fetchCompanies aquí
  useEffect(() => {
    fetchCompanies(); // Esto cargará las empresas si no se cargaron automáticamente
    // Nota: el hook companiesApi ya tiene un useEffect interno que llama a fetchCompanies,
    // pero si por alguna razón no lo hace, este efecto lo asegura.
    // Si el hook ya carga al montarse, este useEffect es redundante pero inofensivo.
    // Puedes eliminarlo si el hook ya carga automáticamente.
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  if (loading) {
    return <LoadingSpinner text="Cargando empresas..." />;
  }

  if (error) {
    return <ErrorMessage error={error} />;
  }

  return (
    <select
      value={value}
      onChange={(e) => onChange(e.target.value)}
      className={`block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 ${className}`}
    >
      <option value="">{placeholder}</option>
      {companies.map((company) => (
        <option key={company.nit} value={company.nit}>
          {company.nit} {company.nombre ? `- ${company.nombre}` : ''}
        </option>
      ))}
    </select>
  );
};